import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';
import en from '../../../../lang/en-us';
import { trackMyRequestPath } from '../utils';
const { dbCommercial } = en;

export default function SWPSuccess(props: any) {
    const { reqId } = props.location.state || {};
    const history = useHistory();
    if (!reqId) {
        history.push('/');
        return null;
    }
    return (
        <div className="curved-bg mf-success">
            <div className="curved-bg-content nct-success-screen">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <img
                            className="change-email-img"
                            src="/images/mf-success-character.png"
                            alt=""
                        />
                        <h3 className="subheading">
                            {dbCommercial.exploreMfs.successScreen.heading}
                        </h3>
                        <p>
                            {dbCommercial.exploreMfs.successScreen.headingInfo}
                            <span>{reqId}</span>.
                        </p>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <Button
                            className="customBtn"
                            onClick={() => history.push(trackMyRequestPath(reqId))}
                        >
                            {dbCommercial.exploreMfs.successScreen.goToTransact}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
